import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './helpers/useAuth';

import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Login from './components/Login';
import Dashboard from './pages/Dashboard';
import CreateStudentFee from './pages/CreateStudentFee';
import StudentReport from './pages/StudentReport';
import ProtectedRoute from './helpers/ProtectedRoutes';
import StudentRegistration from './pages/StudentRegistration';
import UnpaidStudents from './pages/UnpaidStudentsReport';
import ConsultantForm from './pages/CreateConsultant';
import ConsultantReport from './pages/ConsultantReport';
import ConsultantDashboard from './pages/ConsultantDashboard';
import ScrollToTop from './components/ScrollToTop';
import { useState } from 'react';

function App() {
    const [sidebarOpen, setSidebarOpen] = useState(true);
  return (
    <AuthProvider>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 4000,
          style: {
            borderRadius: '10px',
            background: '#333',
            color: '#fff',
          },
        }}
      />

      <Routes>
        <Route path="/login" element={<Login />} />

        <Route element={<ProtectedRoute />}>
          <Route
            element={
              <div className="flex h-screen bg-gray-100">
                <Sidebar sidebarOpen={sidebarOpen}/>
                <div className="flex-1 flex flex-col overflow-hidden">
                  <Header />
                  <main className="flex-1 p-6 overflow-auto">
                    <ScrollToTop />
                    <Outlet />
                  </main>
                </div>
              </div>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="student-registration" element={<StudentRegistration />} />
            <Route path="unpaid-studentfee" element={<UnpaidStudents />} />
            <Route path="create-studentfee" element={<CreateStudentFee />} />
            <Route path="student-report" element={<StudentReport />} />
           <Route path="create-consultant/:id?" element={<ConsultantForm />} />
            <Route path="consultant-report" element={<ConsultantReport />} />
            <Route path="consultant-dashboard/:encodedId" element={<ConsultantDashboard />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;